import isDemo from '@/lib/utils/is_demo';
import { httpDelete, camelify } from '../rest';

export function deleteAdvisorPhoto(httpDelete, camelify, isDemo) {
  return {
    async execute() {
      let data;
      /* istanbul ignore if */
      if (isDemo()) {
        data = {
          photo_url: null,
        };
      } else {
        const response = await httpDelete('/advisor_photos');
        data = response.data;
      }
      return camelify(data);
    },
  };
}

export default deleteAdvisorPhoto(httpDelete, camelify, isDemo);
